enum SalesInvoicePremission {
  Prem_Sales_Invoices_Create = 'Prem_Sales_Invoices_Create',
  Prem_Sales_Invoices_Open = 'Prem_Sales_Invoices_Open',
  Prem_Sales_Invoices_Change_Store = 'Prem_Sales_Invoices_Change_Store',
  Prem_Sales_Invoices_Change_Discount = 'Prem_Sales_Invoices_Change_Discount',
  Prem_Sales_Invoices_Quota_Exceed = 'Prem_Sales_Invoices_Quota_Exceed',
  Prem_Sales_Invoices_See_All = 'Prem_Sales_Invoices_See_All',
  Prem_Sales_Invoices_Rows_Limit_Exceed = 'Prem_Sales_Invoices_Rows_Limit_Exceed',
  Prem_Sales_Invoices_Add_Discount = 'Prem_Sales_Invoices_Add_Discount',
  Prem_Sales_Invoices_Hide_Real_Discounts = 'Prem_Sales_Invoices_Hide_Real_Discounts',
  Prem_Sales_Invoices_Save_With_Red = 'Prem_Sales_Invoices_Save_With_Red',
  Prem_Sales_Invoices_Offers_With_Discount = 'Prem_Sales_Invoices_Offers_With_Discount',
}

export default SalesInvoicePremission;
